import { InStockDiamond } from '@shared/lib/overnight/types';
import Image from 'next/image';
import { useState } from 'react';
import { shapeSampleImages } from './shape-images';
export default function DiamondMainImage({ diamond }: { diamond: InStockDiamond }) {
  const frameMeta = diamond.image360MetaData;
  const fallbackImage =
    shapeSampleImages[diamond.shape.toLowerCase() as keyof typeof shapeSampleImages];
  const vendorImageUrl =
    diamond.vendorImageUrl && `/api/proxy?url=${encodeURIComponent(diamond.vendorImageUrl!)}`;
  const [imageSrc, setImageSrc] = useState(diamond.imageUrl || vendorImageUrl || fallbackImage.src);
  const [isLoading, setIsLoading] = useState(true);

  return (
    <>
      <Image
        src={imageSrc}
        alt={diamond.id}
        className="h-full w-full object-cover object-center"
        width={frameMeta?.width || 400}
        height={frameMeta?.height || 400}
        unoptimized={imageSrc === vendorImageUrl}
        blurDataURL={fallbackImage.src}
        placeholder="blur"
        onError={(e) => {
          setImageSrc(fallbackImage.src);
        }}
        onLoad={(e) => {
          setIsLoading(false);
        }}
      />
      <p className="bg-bd-light/40 @[12em]:block absolute bottom-4 left-1/2 hidden -translate-x-1/2 whitespace-nowrap rounded-md p-1 text-center text-sm text-black">
        {isLoading
          ? 'Loading...'
          : imageSrc === fallbackImage.src
            ? 'Not an Actual Diamond Image'
            : 'Actual Diamond Image'}
      </p>
    </>
  );
}
